'use strict';

angular.module('theme').component('contentOverlay', {
	templateUrl: 'component/content-overlay.html',
	bindings: {
		show: '=',
		onDismiss: '&'
	},
	transclude: true,
	controller: function () {
		var self = this;

		self.dismiss = function() {
			self.show = false;
			self.onDismiss();
		};

	}
});
